import { CSS_BREAKPOINTS } from '@sbercloud/uikit-product-utils';
import { useEffect, useState } from 'react';

import { useAppNavigationCtx, useLayoutCtx, useServerDataCtx } from '@/hooks/ctx';
import { useLayoutType } from '@/root/src/hooks';
import { Fn } from '@/types/common';
import { getScrollToAnchorOffsetDelta, scrollToAnchor } from '@/utils/navigation';
import { skipHashTag } from '@/utils/strings';

export const useAnchor = () => {
  const [anchor, setAnchor] = useState('');

  useEffect(() => {
    const updateAnchor = () => {
      const hash = window.location.hash;
      const anchorWithoutHash = skipHashTag(hash);

      if (Boolean(anchorWithoutHash)) {
        setAnchor(anchorWithoutHash);
      }
    };
    updateAnchor();
    window.addEventListener('hashchange', updateAnchor);

    return () => {
      window.removeEventListener('hashchange', updateAnchor);
    };
  }, []);

  return { anchor };
};

export const useScrollToAnchorOnMount = (anchor: string, onScrollLEnd: Fn<number, void>) => {
  const { layoutWrapperRef } = useLayoutCtx();
  const { headers } = useServerDataCtx();
  const layoutType = useLayoutType(CSS_BREAKPOINTS, headers.xLayoutType);
  const { activeAppNavigationItemByRoute } = useAppNavigationCtx();

  useEffect(() => {
    if (anchor) {
      const anchorWithoutHash = anchor.startsWith('#') ? anchor.substring(1) : anchor;

      return scrollToAnchor(anchorWithoutHash, {
        scrollBehavior: 'smooth',
        onSuccessScroll: onScrollLEnd,
        layoutWrapperRef,
        offsetDelta: getScrollToAnchorOffsetDelta(layoutType, Boolean(activeAppNavigationItemByRoute)),
      });
    }
    onScrollLEnd(Date.now());
  }, [anchor]);
};
